import { render, staticRenderFns } from "./InputExpandable.vue?vue&type=template&id=3bbc799a&scoped=true"
import script from "./InputExpandable.vue?vue&type=script&lang=js"
export * from "./InputExpandable.vue?vue&type=script&lang=js"
import style0 from "./InputExpandable.vue?vue&type=style&index=0&id=3bbc799a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbc799a",
  null
  
)

export default component.exports